/** "Evocation in Magic of Faerûn and Player's Guide to Faerûn": each value a filter matched, with the books that print it so. */
export function matchedInText(matches) {
  const byValue = new Map();
  for (const m of matches) {
    const books = byValue.get(m.value) || [];
    if (m.rulebook_name && !books.includes(m.rulebook_name)) books.push(m.rulebook_name);
    byValue.set(m.value, books);
  }
  const join = (xs) => (xs.length < 2 ? xs.join('') : `${xs.slice(0, -1).join(', ')} and ${xs[xs.length - 1]}`);
  return [...byValue].map(([value, books]) => (books.length ? `${value} in ${join(books)}` : value)).join('; ');
}
